import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'

export const billingDetailService = service
  .enhanceEndpoints({ addTagTypes: ['BillingDetail'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBillingDetails: builder.query<
        Res['billingDetails'],
        Req['getBillingDetails']
      >({
        providesTags: ['BillingDetail'],
        query: (query: Req['getBillingDetails']) => ({
          url: `customers/companies/${query.company_id}/subscriptions/${query.subscription_id}/billing-detail`,
        }),
      }),
    }),
  })

export async function getBillingDetails(
  store: any,
  data: Req['getBillingDetails'],
  options?: Parameters<
    typeof billingDetailService.endpoints.getBillingDetails.initiate
  >[1],
) {
  store.dispatch(
    billingDetailService.endpoints.getBillingDetails.initiate(data, options),
  )
  return Promise.all(
    store.dispatch(billingDetailService.util.getRunningQueriesThunk()),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useGetBillingDetailsQuery,
  // END OF EXPORTS
} = billingDetailService

/* Usage examples:
const { data, isLoading } = useGetBillingDetailsQuery({ company_id: '2', subscription_id: '123' }, {}) //get hook
billingDetailService.endpoints.getBillingDetails.select({company_id: '2', subscription_id: '123'})(store.getState()) //access data from any function
*/
